module.exports = __webpack_public_path__ + "img/engergy.0744b828.jpg";